import { render, staticRenderFns } from "./permissionAccess.vue?vue&type=template&id=4b721cb4&scoped=true"
import script from "./permissionAccess.vue?vue&type=script&lang=js"
export * from "./permissionAccess.vue?vue&type=script&lang=js"
import style0 from "./permissionAccess.vue?vue&type=style&index=0&id=4b721cb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b721cb4",
  null
  
)

export default component.exports